/* RichTextEditor.mui.tsx */
import { Stack, Typography } from '@mui/material'
import React from 'react'

import { RichTextEditorCore } from '../../RichText'

export type RichTextEditorMuiProps = {
  label?: string
  placeholder?: string
  disabled?: boolean
  content?: string
  onChange?: (html: string) => void
  error?: boolean
  helperText?: string
  value?: string
  onBlur?: () => void
  variant?: 'outlined' | 'standard'
}

const RichTextEditorMui: React.FC<RichTextEditorMuiProps> = ({
  label = 'Notiz',
  placeholder = 'Text hier eingeben …',
  disabled,
  value,
  onBlur,
  onChange,
  error = false,
  helperText
}) => (
  <Stack spacing={1}>
    <Typography>{label}</Typography>
    <RichTextEditorCore
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      features={['table']}
      syncExternalValue
    />
    {(error || helperText) && (
      <Typography
        variant="caption"
        color={error ? 'error' : 'textSecondary'}
        className="rich-text-helper-text"
      >
        {helperText}
      </Typography>
    )}
  </Stack>
)

export default RichTextEditorMui
